import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/android-chrome-192x192.png")